import * as React from "react";
import {
  CampaignCreatedActivity,
  isCampaignCreatedActivity,
  CampaignUpdatedActivity,
  isCampaignUpdatedActivity,
  ReviewCreatedActivity,
  isReviewCreatedActivity,
  ReviewUpdatedActivity,
  isReviewUpdatedActivity,
  ReviewDocumentAddedActivity,
  isReviewDocumentAddedActivity,
  ReviewDocumentDeletedActivity,
  isReviewDocumentDeletedActivity,
  ReportCheckedActivity,
  isReportCheckedActivity,
  ReportFilledActivity,
  isReportFilledActivity,
  UserCreatedActivity,
  isUserCreatedActivity,
  TemplateCreatedActivity,
  isTemplateCreatedActivity,
  TemplateUpdatedActivity,
  isTemplateUpdatedActivity,
  UserUpdatedActivity,
  isUserUpdatedActivity,
  isUserDocumentAddedActivity,
  UserDocumentAddedActivity,
} from "./ActivityImpl";

import {
  CompanyUpdatedActivity,
  isCompanyUpdatedActivity,
} from "./ActivityImpl/CompanyUpdatedActivity";
import useTranslations from "../../hooks/useTranslations";
import { GroupCreatedActivity, isGroupCreatedActivity } from "./ActivityImpl/GroupCreatedActivity";
import { GroupUpdatedActivity, isGroupUpdatedActivity } from "./ActivityImpl/GroupUpdatedActivity";
import { isUserDocumentDeletedActivity, UserDocumentDeletedActivity } from "./ActivityImpl/UserDocumentDeletedActivity";

import { ActivityFragment } from '../../graphql/generated/definitions';

interface Props {
  activity: ActivityType;
}

export type ActivityConfig<T extends ActivityFragment> = {
  Component: React.ElementType;
  typeValidator: (q: ActivityFragment) => q is T;
};

const activityConfig: ActivityConfig<ActivityFragment>[] = [
  {
    Component: UserUpdatedActivity,
    typeValidator: isUserUpdatedActivity,
  },
  {
    Component: UserCreatedActivity,
    typeValidator: isUserCreatedActivity,
  },
  {
    Component: UserDocumentAddedActivity,
    typeValidator: isUserDocumentAddedActivity,
  },
  {
    Component: UserDocumentDeletedActivity,
    typeValidator: isUserDocumentDeletedActivity,
  },
  {
    Component: ReviewDocumentAddedActivity,
    typeValidator: isReviewDocumentAddedActivity,
  },
  {
    Component: ReviewDocumentDeletedActivity,
    typeValidator: isReviewDocumentDeletedActivity,
  },
  {
    Component: ReportFilledActivity,
    typeValidator: isReportFilledActivity,
  },
  {
    Component: ReportCheckedActivity,
    typeValidator: isReportCheckedActivity,
  },
  {
    Component: ReportCheckedActivity,
    typeValidator: isReportCheckedActivity,
  },
  {
    Component: ReviewUpdatedActivity,
    typeValidator: isReviewUpdatedActivity,
  },
  {
    Component: ReviewCreatedActivity,
    typeValidator: isReviewCreatedActivity,
  },
  {
    Component: GroupCreatedActivity,
    typeValidator: isGroupCreatedActivity,
  },
  {
    Component: GroupUpdatedActivity,
    typeValidator: isGroupUpdatedActivity,
  },
  {
    Component: CampaignUpdatedActivity,
    typeValidator: isCampaignUpdatedActivity,
  },
  {
    Component: CampaignCreatedActivity,
    typeValidator: isCampaignCreatedActivity,
  },
  {
    Component: TemplateUpdatedActivity,
    typeValidator: isTemplateUpdatedActivity,
  },
  {
    Component: TemplateCreatedActivity,
    typeValidator: isTemplateCreatedActivity,
  },
  {
    Component: CompanyUpdatedActivity,
    typeValidator: isCompanyUpdatedActivity,
  },
];

const Activity: React.FC<Props> = ({ activity }) => {
  const Config = activityConfig.find((c) => c.typeValidator(activity));
  const t = useTranslations()

  return Config ? (
    <Config.Component activity={activity} />
  ) : (
    <div>{t("appErrors.componentUnknown", {key: activity.key})}</div>
  );
};

export default Activity;
